import { LazyAction, LazyModule, preloadScriptChunk } from 'owa-bundling';
export { default as datapoints } from './datapoints';
preloadScriptChunk('MailMessageActions');
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "MailMessageActions" */ './lazyIndex');
});
export var lazyNewMessage = new LazyAction(lazyModule, function (m) { return m.newMessage; });
export var lazyReplyToConversation = new LazyAction(lazyModule, function (m) { return m.replyToConversation; });
export var lazyForwardConversation = new LazyAction(lazyModule, function (m) { return m.forwardConversation; });
export var lazyPrintConversation = new LazyAction(lazyModule, function (m) { return m.printConversation; });
export var lazyReplyToItem = new LazyAction(lazyModule, function (m) { return m.replyToItem; });
export var lazyForwardItem = new LazyAction(lazyModule, function (m) { return m.forwardItem; });
export var lazyPrintItem = new LazyAction(lazyModule, function (m) { return m.printItem; });
export var lazyShowConversationInImmersiveReader = new LazyAction(lazyModule, function (m) { return m.showConversationInImmersiveReader; });
export var lazyReplyWithText = new LazyAction(lazyModule, function (m) { return m.replyWithText; });
export { ReplyWithTextFeatures };
//# sourceMappingURL=index.js.map